var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.precision')
    }
  }, [_c('el-input-number', {
    staticClass: "hide-spin-button",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.optionModel.precision),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "precision", $$v)
      },
      expression: "optionModel.precision"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab6ff94","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/precision-editor.vue
// module id = null
// module chunks = 